import React from "react";

const services = [
	"IT Consulting & Strategy",
	"Cloud Infrastructure & DevOps",
	"Software & Web Development",
	"Network & Systems Integration",
	"IT Support & Managed Services",
];

const Services = () => (
	<section className="py-16 bg-slate-50" id="services">
		<div className="max-w-5xl mx-auto px-4">
			<h3 className="text-3xl font-semibold mb-6">Our Services</h3>
			<ul className="grid md:grid-cols-2 gap-6 list-disc pl-6 text-slate-700 font-semibold">
				{services.map((service, index) => (
					<li key={index}>{service}</li>
				))}
			</ul>
		</div>
	</section>
);

export default Services;
